import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down4",
  "use": "icon-down4-usage",
  "viewBox": "1 0 10 10",
  "content": "<symbol viewBox=\"1 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-down4\">\n    <path d=\"M2.14645 4.14645C2.34171 3.95118 2.65829 3.95118 2.85355 4.14645L6 7.29289L9.14645 4.14645C9.34171 3.95118 9.65829 3.95118 9.85355 4.14645C10.0488 4.34171 10.0488 4.65829 9.85355 4.85355L6.35355 8.35355C6.15829 8.54882 5.84171 8.54882 5.64645 8.35355L2.14645 4.85355C1.95118 4.65829 1.95118 4.34171 2.14645 4.14645Z\" fill=\"#999999\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol